type ErrTuple<E> = Readonly<[null, E]>

type ErrProps<E> = Readonly<{ error: E }>

export type Err<E> = ErrTuple<E> & ErrProps<E>

/**
 * Returns an Err object with the given error object/value.
 * @param error - The error object/value
 * @returns An Err object with the given error object/value.
 */
export const err = <E>(error: E): Err<E> => {
  return {
    error,
    0: null,
    1: error,
    length: 2,
    [Symbol.iterator]: function* () {
      yield null
      yield error
    },
  } as Err<E>
}

/**
 * @param error The error object to be inspected
 * @param field The error property to check
 * @param value The expected value
 * @returns boolean indicating it the error has a property with the specified name and value
 */
export const checkKeyInUnknownError = (
  error: unknown,
  field: string,
  value: string | number | boolean
) => {
  return (
    typeof error === 'object' &&
    error !== null &&
    field in error &&
    error[field as keyof typeof error] === value
  )
}
